import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const TobaccoTypeIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros
    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "name",
            label: "Name",
            placeholder: "Search by name..."
        }
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        { 
            title: 'Name', 
            dataIndex: 'name', 
            key: 'name', 
            sortable: true 
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 100,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/tobaccoType/edit/${record.tobaccoTypeID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Tobacco Type"
            apiEndpoint="/TobaccoType/getAllPaginated"
            toggleActiveEndpoint="/TobaccoType/toggleActive"
            toggleDeletedEndpoint="/TobaccoType/toggleDeleted"
            newRoute="/tobaccoType/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="tobaccoTypeID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default TobaccoTypeIndex;
